export const PERMISSIONS = {
  ACCOUNTS_SWITCH: 'accounts.switch',
  AUTOMATION_CONFIGURE: 'automation.configure',
};

export const canAccess = (authorization, permission) =>
  Boolean(authorization && authorization.permissions && authorization.permissions.includes(permission));
